























































































































import { Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import { UserHelper } from '@/helper/user';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import ShoppingCartOverviewItem from '@/components/shopping-cart/ShoppingCartOverviewItem.vue';
import ShoppingCartOverviewItems from '@/components/shopping-cart/ShoppingCartOverviewItems.vue';
import ShoppingCartOverviewMetadata from '@/components/shopping-cart/ShoppingCartOverviewMetadata.vue';
import { ShoppingCart } from '@/entities/ShoppingCart';
import { ShippingMethod } from '@/entities/ShippingMethod';
import BaseMixin from '@/mixins/BaseMixin';
import { ShoppingCartModuleTypes } from '../../store/modules/shopping-cart';
import { OrderMethod } from '../../entities/OrderMethod';

@Component({
    components: {
        LoadingIndicator,
        ShoppingCartOverviewItem,
        ShoppingCartOverviewMetadata,
        ShoppingCartOverviewItems,
    },
})
export default class ShoppingCartOverview extends Mixins(BaseMixin) {
    @Prop(String)
    public checkoutUrl!: string;
    @Prop(String)
    private partDetailLink!: string;
    @Prop(Boolean)
    private hideCheckoutButton!: boolean;

    private shippingMethods: string[] = Object.keys(ShippingMethod);

    public get isShoppingCartEmpty(): boolean {
        return !this.activeShoppingCart || this.activeShoppingCart.cartItems.length <= 0;
    }

    public get activeShoppingCart(): ShoppingCart {
        return this.$store.getters[ShoppingCartModuleTypes.getters.activeShoppingCart];
    }

    public get checkoutUrlWithShoppingCartId(): string {
        return `${this.checkoutUrl}/${this.activeShoppingCart.id}`;
    }

    public get shoppingCarts(): ShoppingCart[] {
        return this.$store.getters[ShoppingCartModuleTypes.getters.shoppingCarts];
    }

    public get orderMethods(): OrderMethod[] {
        return this.$store.getters[ShoppingCartModuleTypes.getters.orderMethods];
    }

    public get isUserAuthenticated(): boolean {
        return UserHelper.isAuthenticated();
    }

    public get hasCustomerShippingCosts(): boolean {
        return UserHelper.hasShippingCosts();
    }

    private saveMetadata(metadata: { cartName: string; orderName: string }): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.updateActiveShoppingCartMetadata, {
            cartName: metadata.cartName,
            orderName: metadata.orderName,
        });
    }

    private selectActiveShoppingCart(event: Event): void {
        const selectedShoppingCartId = parseInt((event.target as HTMLSelectElement).value, 10);
        if (selectedShoppingCartId == null || isNaN(selectedShoppingCartId)) {
            return;
        }
        this.$store.dispatch(ShoppingCartModuleTypes.actions.setActiveShoppingCart, {
            shoppingCartId: selectedShoppingCartId,
        });
    }

    private selectShippingMethodForCart(event: Event): void {
        const selectedShippingMethodValue = (event.target as HTMLSelectElement).value;
        const selectedShippingMethod = ShippingMethod[selectedShippingMethodValue as keyof typeof ShippingMethod];

        this.$store.dispatch(ShoppingCartModuleTypes.actions.updateActiveShoppingCartShippingMethod, {
            shippingMethod: selectedShippingMethod,
        });
    }

    private selectOrderMethodForCart(event: Event): void {
        const selectedOrderMethodValue = (event.target as HTMLSelectElement).value;

        this.$store.dispatch(ShoppingCartModuleTypes.actions.updateActiveShoppingCartOrderMethod, {
            orderMethod: selectedOrderMethodValue,
        });
    }
}
